<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Forms from "../../../mixins/Forms";
import Tickets from "../../../mixins/Tickets";
import axios from 'axios';
import { mapGetters, mapActions } from "vuex";
import DateTicketOpenedFilter from '../reporting/show/Filters/DateTicketOpenedFilter.vue';
import AgentsFilter from '../reporting/show/Filters/AgentsFilter.vue';
import TravelConsultantsFilter from "../reporting/show/Filters/TravelConsultantsFilter.vue";
import StatusFilter from '../reporting/show/Filters/StatusFilter.vue';
import PriorityFilter from '../reporting/show/Filters/PriorityFilter.vue';
import DifficultyFilter from '../reporting/show/Filters/DifficultyFilter.vue';
import DateTicketResolvedFilter from '../reporting/show/Filters/DateTicketResolvedFilter.vue';
import DateTicketClosedFilter from '../reporting/show/Filters/DateTicketClosedFilter.vue';
import CausedByItgErrorFilter from '../reporting/show/Filters/CausedByItgErrorFilter.vue';
import TagFilter from '../reporting/show/Filters/TagFilter.vue';
import LoadingScreen from '../../../components/LoadingScreen.vue';

const FREQUENCY_OPTIONS = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
];

const REPORT_ON_OPTIONS = [
    { label: 'Tickets Opened', value: 'opened' },
    { label: 'Tickest Resolved', value: 'resolved' },
    { label: 'Tickets Closed', value: 'closed' }
];

/**
 * Projects-create component
 */
export default {
    page: {
        title: "Edit Automated Report",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, DateTicketOpenedFilter, AgentsFilter, TravelConsultantsFilter, StatusFilter, PriorityFilter, DifficultyFilter, DateTicketResolvedFilter, DateTicketClosedFilter, CausedByItgErrorFilter, TagFilter, LoadingScreen },
    mixins: [Forms, Tickets],
    data() {
        return {
            title: "Edit Automated Report",

            isLoading: false,
            automatedReportFromServer: null,

            reportOn: 'opened', // opened, closed, resolved

            frequencyOptions: FREQUENCY_OPTIONS,

            reportOnOptions: REPORT_ON_OPTIONS,

            items: [
                {
                    text: "Automated Reports",
                    href: "/automated-reporting"
                },
                {
                    text: "Edit Automated Report",
                    active: true
                }
            ],

            serverErrors: [],
            isSaving: false,

            name: '',
            description: '',
            startDate: null,
            endDate: null,
            frequency: 'weekly',
            recipients: [
                {
                    email: ''
                },
                // {
                //     email: ''
                // }
            ]
        };
    },
    watch: {
    },
    mounted() {
    },
    created() {
        this.blankSlate();
        this.loadAgents();
        this.loadAutomatedReport();
    },
    computed: {
        ...mapGetters('reportEditor', {
            paramsToUse: 'paramsToUse'
        }),

        automatedReportId() {
            return this.$route.params.id;
        },

        recipientsAsCsv() {
            return this.recipients.filter(r => r.email && r.email.trim().length).map(r => r.email.trim()).join(',');
        }
    },
    methods: {
        ...mapActions('reportEditor', {
            loadAgents: 'loadAgents',
            blankSlate: 'blankSlate',
            setParamsFromQuery: 'setParamsFromQuery'
        }),

        loadAutomatedReport() {
            let vm = this;
            vm.isLoading = true;
            vm.automatedReportFromServer = null;
            axios.get(API_BASE + '/automated-reports/' + this.automatedReportId).then(response => {
                vm.isLoading = false;
                vm.automatedReportFromServer = response.data;
                vm.name = vm.automatedReportFromServer.name;
                vm.description = vm.automatedReportFromServer.description;
                vm.reportOn = vm.automatedReportFromServer.report_on;
                vm.frequency = vm.automatedReportFromServer.frequency;
                vm.endDate = vm.automatedReportFromServer.end_date ? window.moment(vm.automatedReportFromServer.end_date).format('YYYY-MM-DD') : null;
                vm.recipients = String(vm.automatedReportFromServer.recipients).split(',').map(r => ({ email: r.trim() }));
                vm.setParamsFromQuery(vm.automatedReportFromServer.query);
            }).catch(e => {
                console.log(e);
                vm.isLoading = false;
            });
        },

        addRecipient() {
            this.recipients.push({
                email: ''
            });
        },

        attemptSave() {
            let errors = [];

            if (!this.name || !this.name.trim().length) {
                errors.push('Name is required.');
            }

            if (!this.description || !this.description.trim().length) {
                errors.push('Description is required.');
            }

            if (!this.reportOn || !this.reportOn.trim().length) {
                errors.push('Report on is required.');
            }

            // if (!this.startDate) {
            //     errors.push('Start date is required.');
            // }

            if (!this.frequency || !this.frequency.trim().length) {
                errors.push('Frequency is required.');
            }

            if (!this.recipientsAsCsv || !this.recipientsAsCsv.trim().length) {
                errors.push('At least one recipient is required.');
            }

            if (errors.length) {
                this.serverErrors = errors;
                return false;
            }

            this.save();
        },

        save() {
            let vm = this;
            vm.serverErrors = [];

            if (this.isSaving) {
                return false;
            }

            let formParams = {
                name: vm.name,
                description: vm.description,
                // start_date: vm.startDate,
                report_on: vm.reportOn,
                end_date: vm.endDate,
                frequency: vm.frequency,
                // recipients: vm.recipients,
                query: JSON.stringify(vm.paramsToUse),
                recipients: vm.recipientsAsCsv
            };

            vm.isSaving = true;
            axios.put(API_BASE + '/automated-reports/' + this.automatedReportId, formParams).then(() => {
                vm.isSaving = false;
                vm.$router.push('/automated-reporting');
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.setErrors(e);
            });
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <PageHeader :title="title" :items="items" />
                <errors :error-list="serverErrors"></errors>
                <loading-screen :is-loading="isSaving||isLoading"></loading-screen>
            </div>
        </div>

        <div class="row justify-content-center create-automated-report">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <b class="section-title">Basic Details</b>
                        <hr>

                        <!-- Name -->
                        <div class="mb-4">
                            <label for="name">Name *</label>
                            <input type="text" class="form-control" id="name" v-model="name"
                                placeholder="Enter a name for this report">
                        </div>
                        <!-- / Name -->

                        <!-- Description -->
                        <div class="mb-2">
                            <label for="description">Description *</label>
                            <textarea class="form-control" id="description" v-model="description" rows="4"
                                placeholder="Enter a description of this report"></textarea>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body automated-reporting-wrapper">
                        <b class="section-title">Filters</b>
                        <hr />

                        <!-- Report On-->
                        <div class="mb-4">
                            <label for="reportOn">Report On *</label>
                            <v-select v-model="reportOn" label="label" placeholder="Please select a report on"
                                :clearable="false" :reduce="option => option.value" :options="reportOnOptions"></v-select>
                        </div>
                        <!-- / Report On-->

                        <!-- Filters -->
                        <tag-filter></tag-filter>
                        <!-- <date-ticket-opened-filter></date-ticket-opened-filter> -->
                        <!-- <date-ticket-resolved-filter></date-ticket-resolved-filter> -->
                        <!-- <date-ticket-closed-filter></date-ticket-closed-filter> -->
                        <agents-filter></agents-filter>
                        <travel-consultants-filter></travel-consultants-filter>
                        <status-filter></status-filter>
                        <priority-filter></priority-filter>
                        <difficulty-filter></difficulty-filter>
                        <caused-by-itg-error-filter v-if="false"></caused-by-itg-error-filter>
                        <!-- / Filters -->
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <b class="section-title">Reporting Schedule</b>
                        <hr />

                        <!-- Frequency -->
                        <div>
                            <label>Frequency *</label>
                            <v-select v-model="frequency" label="label" placeholder="Please select a frequency"
                                :clearable="false" :reduce="option => option.value" :options="frequencyOptions"></v-select>
                        </div>
                        <!-- / Frequency -->

                        <!-- End Date -->
                        <div class="mt-4">
                            <div>
                                <label>End Date</label>
                            </div>
                            <el-date-picker size="large" value-format="yyyy-MM-dd" style="width: 100%;" v-model="endDate"
                                placeholder="End Date">
                            </el-date-picker>
                        </div>
                        <!-- / End Date -->

                        <!-- <div class="row">
                            <div class="col-md-6">
                                <div>
                                    <label>Start Date *</label>
                                </div>
                                <el-date-picker size="large" value-format="yyyy-MM-dd" style="width: 100%;"
                                    v-model="startDate" placeholder="Start Date">
                                </el-date-picker>
                            </div>
                            <div class="col-md-12">

                            </div>
                        </div> -->
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <b class="section-title">Recipients</b>
                        <hr>

                        <div class="recipients">
                            <div class="recipient mb-3" v-for="(recipient, i) in recipients" :key="`recipient-${i}`">
                                <div class="left">
                                    <input type="text" class="form-control" placeholder="Enter email address"
                                        v-model="recipient.email">
                                </div>
                                <div class="right">
                                    <button class="btn btn-danger" v-if="recipients.length > 1"
                                        @click="recipients.splice(i, 1)">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Add Recipient -->
                            <a href="#" class="btn btn-itg" @click.prevent="addRecipient">+ Add Recipient</a>
                            <!-- / Add Recipient -->
                        </div>
                    </div>
                </div>

                <!-- Save Button -->
                <div class="pt-2">
                    <button class="btn btn-itg btn-itg-dark pl-3 pr-3" @click.prevent="attemptSave">Save Report</button>
                </div>
                <!-- / Save Button -->

            </div>
        </div>

    </Layout>
</template>

<style scoped lang="scss">
.create-automated-report {
    .section-title {
        font-weight: 600;
        font-size: 14px;
        // color: #000; 
    }

    .report-filter {
        // background: rgb(248, 248, 251);
        background-color: #f3f5f7;
        // color: #12344d;

        // border: 1px solid #cfd7df;
        // background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f3f5f7));
        // background-image: linear-gradient(to bottom, #fff, #f3f5f7);
    }

    .recipient {
        display: flex;

        .left {
            flex-grow: 1;
        }

        .right {
            flex-shrink: 1;
            padding-left: 10px;
        }
    }
}
</style>